<template>
  <div class="header bg-white q-pa-sm q-pb-md rounded dropshadow q-mb-md" :class="active ? 'pointer' : 'faded'">
    <h5 class="text q-my-xs">
      <i :class="image" style="background-color: var(--primary-color-background); padding: 4px" />
      {{ header }}
    </h5>
  </div>
</template>

<script>
/**
 * This component represents common UI for displaying the status in the progress list
 */
export default {
  name: 'SectionHeader',
  props: {
    header: String,
    image: String,
    active: Boolean
  }
};
</script>

<style lang="sass" scoped>
img
  padding: 10px;
  margin-right: 7px;
  display: inline-block;
  background: #E9F3FD;
  vertical-align: middle;
h5
  margin-bottom: 0;
  padding-bottom: 0;
i
  vertical-align: bottom;
  font-size: 30px;
</style>
